<script>
  import "firebase/storage";

  import { getContext } from "svelte";

  export let invoice = {};

  const firebase = getContext("firebase").getFirebase();
  const storage = firebase.storage().ref();

  const formatDate = function (date) {
    if (!date) {
      return "";
    }
    const date_obj = date.toDate();
    const month = date_obj.getMonth();
    const day = date_obj.getDate();
    const year = date_obj.getFullYear().toString().slice(-2);
    return `${month}/${day}/${year}`;
  };

  const openPdf = async function (path) {
    if (!path) {
      return;
    }
    const url = await storage.child(path).getDownloadURL();
    if (!url) {
      return;
    }
    window.open(url, "_blank");
  };
</script>

<div id="outer">
  <span id="date">{formatDate(invoice.date)}</span>
  <div id="inner">
    <div id="main">
      <span>Invoice No. {invoice.id}</span>
      <div id="icon-button">
        <i class="fas fa-download" on:click={openPdf(invoice.path)} />
      </div>
    </div>
    {#if invoice.paid}
      <span class="pay-status" id="paid">Paid</span>
    {:else}
      <span class="pay-status" id="unpaid">Unpaid</span>
    {/if}
  </div>
</div>

<style>
  #outer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    box-shadow: var(--box-shadow-light);
    margin: 8px 0px;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid var(--light-grey);
  }

  #inner {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
  }

  #main {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }

  #date {
    color: var(--dark-grey);
    margin-right: 20px;
  }

  #icon-button {
    background-color: var(--off-black);
    color: white;
    width: 24px;
    height: 24px;
    text-align: center;
    overflow: hidden;
    border-radius: 5px;
    margin-left: 10px;
  }

  #icon-button:hover {
    cursor: pointer;
    background-color: var(--black);
  }

  i {
    font-size: 16px;
    margin-top: 4px;
  }

  .pay-status {
    padding: 10px 10px 7px 10px;
    border-radius: 20px;
    color: white;
  }

  #paid {
    background-color: var(--positive);
  }

  #unpaid {
    background-color: var(--negative);
  }
</style>
